const updateBiAccount = require('services/api/beautyInsider/updateBiAccount');

function updateBeautyPreferences(data) {
    return updateBiAccount(data).then(response => {
        if (response.responseStatus === 200) {
            return Promise.resolve(response);
        }

        return Promise.reject(response);
    });
}

module.exports = updateBeautyPreferences;
